export enum LocalStorageKey {
  rememberMe = 'remember_me',
}
